import { Component, input } from '@angular/core';
import { BspkIcon, BspkTxt } from '@bspk/ngx-ui';
import { RouterLink } from '@angular/router';

export interface BreadcrumbItem {
  label: string;
  href: string;
}

@Component({
  selector: 'bspk-breadcrumbs',
  templateUrl: 'breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  imports: [BspkIcon, RouterLink, BspkTxt],
})
export class BreadcrumbsComponent {
  readonly items = input.required<BreadcrumbItem[]>();
}
